export default __webpack_public_path__ + "static/media/empty-sprint-in-table.be5cdb7c.svg";